import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { getEventEmitter } from  '@process-advisor/process-miner/processMiner/processMiner';

export type ContextMenuOption = {
    text: string,
    event?: () => void,
    subMenuOptions?: ContextMenuOption[]
}

type ShowContextMenuProps = { x: number, y: number, options: ContextMenuOption[] } & ApiMethodBase;

export const showContextMenu = ({ eventEmitter, x, y, options }: ShowContextMenuProps) => {
    if (!eventEmitter) {eventEmitter = getEventEmitter()}  // seems to be a bug with passing the eventemitter from context menus?
    eventEmitter.emit(Event.showContextMenu, { x, y, options });
};

export const hideContextMenu = ({ eventEmitter }: ApiMethodBase) => {
    if (!eventEmitter) {eventEmitter = getEventEmitter()}
    eventEmitter.emit(Event.hideContextMenu);
};

